
import { defineComponent, ref, onMounted, nextTick, watch } from "vue";
import * as Yup from "yup";
import { ErrorMessage, Field, Form } from "vee-validate";
import store from "@/store";
import { PasswordMeterComponent } from "@/assets/ts/components";
import Swal from "sweetalert2/dist/sweetalert2.js";
import ApiService from "@/core/services/ApiService";
import VueCountdown from "@chenfengyuan/vue-countdown";
//import BxRegisterConfirmModal from "@/components/modals/forms/RegisterConfirmModal.vue";
import { useSignalR } from "@dreamonkey/vue-signalr";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
interface RegisterTypeC {
  rid: null | string;
  pid: null | string;
  mobileNumber: string;
  bank: string;
  accNo: string;
  firstName: string;
  lastName: string;
  password: string;
  promotionId: null | string;
  sponsorId: string;
  seoKey: string;
  knowMe: string;
}
export default defineComponent({
  name: "register-component-20230223",
  components: {
    ErrorMessage,
    Field,
    Form,
    VueCountdown,
    //BxRegisterConfirmModal,
    Loading,
  },
  methods: {
    startCountdown: function () {
      this.counting = true;
    },
    onCountdownEnd: function () {
      this.counting = false;
    },
    reset: function () {
      this.state = "";
    },
  },
  props: {
    callTime: { type: Number, required: false },
  },
  emits: ["register-complete"],
  setup(props, { emit }) {
    //const router = useRouter();
    const value = ref("apps");
    const signUpCode = ref("");
    const state = ref("");
    const sponsorId = ref("");
    const seoId = ref("");
    const referId = ref("");
    const otpRefNo = ref("");
    const stateTitle = ref("");
    const banks = ref([]);
    const dataTemp = ref({});
    const counting = ref(false);
    const dna = ref("");
    const loadingAcc = ref(false);
    const isLoading = ref(false);

    const submitStepA1ButtonRef = ref<HTMLButtonElement | null>(null);
    const submitStepA2ButtonRef = ref<HTMLButtonElement | null>(null);
    const submitStepA3ButtonRef = ref<HTMLButtonElement | null>(null);
    const submitStepB1ButtonRef = ref<HTMLButtonElement | null>(null);
    const submitStepB2ButtonRef = ref<HTMLButtonElement | null>(null);
    const submitStepB3ButtonRef = ref<HTMLButtonElement | null>(null);
    const submitStepC1ButtonRef = ref<HTMLButtonElement | null>(null);
    const submitStepC2ButtonRef = ref<HTMLButtonElement | null>(null);
    const mobileNumberInputRef = ref<HTMLInputElement | null>(null);
    const accNoInputRef = ref<HTMLInputElement | null>(null);
    const bankInputRef = ref<HTMLSelectElement | null>(null);
    const signalr = useSignalR();
    const registerCFormData = ref<RegisterTypeC>({
      rid: null,
      pid: null,
      mobileNumber: "",
      bank: "",
      accNo: "",
      firstName: "",
      lastName: "",
      password: "",
      promotionId: null,
      sponsorId: "",
      seoKey: "",
      knowMe: "",
    });
    const knowMe = ref([]);

    const schemaStepA1 = Yup.object().shape({
      mobileNumber: Yup.string()
        .required("* กรุณากรอกเบอร์โทรศัพท์")
        .matches(/^(0[0-9]{9})$/, "* เบอร์โทรศัพท์ไม่ถูกต้อง")
        .label("เบอร์โทรศัพท์"),
    });
    const schemaStepA2 = Yup.object().shape({
      otp: Yup.string()
        .required("* กรุณากรอกรหัส OTP")
        .matches(/^([0-9]{6})$/, "* รหัส OTP ไม่ถูกต้อง")
        .label("รหัส OTP"),
      bank: Yup.string().required("* กรุณาเลือกธนาคาร").label("ธนาคาร"),
      accNo: Yup.string()
        .required("* กรุณากรอกเลขที่บัญชี")
        .matches(/^([0-9]{10,12})$/, "* เลขที่บัญชีไม่ถูกต้อง")
        .label("เลขที่บัญชี"),
    });
    const schemaStepA3 = Yup.object().shape({
      password: Yup.string()
        .required("* กรุณากรอกรหัสผ่าน")
        .min(6, "* รหัสผ่านความยาวต้องไม่ต่ำกว่า 6 ตัวอักษร")
        .label("รหัสผ่าน"),
      password_confirmation: Yup.string()
        .required("* กรุณายืนยันรหัสผ่านใหม่อีกครั้ง")
        .oneOf([Yup.ref("password"), null], "รหัสผ่านไม่ตรงกัน")
        .label("ยืนยันรหัสผ่าน"),
      promotionId: Yup.string().label("โปรโมชั่น"),
      knowMe: Yup.string().when((obj, schema) => {
        //your condition here
        if (knowMe.value) {
          return schema
            .required("* กรุณาเลือกรู้จักเราช่องทางไหน")
            .label("รู้จักเราช่องทางไหน");
        }
        return schema.notRequired().label("รู้จักเราช่องทางไหน");
      }),
    });

    const schemaStepB1 = Yup.object().shape({
      mobileNumber: Yup.string()
        .required("* กรุณากรอกเบอร์โทรศัพท์")
        .matches(/^(0[0-9]{9})$/, "* เบอร์โทรศัพท์ไม่ถูกต้อง")
        .label("เบอร์โทรศัพท์"),
    });
    const schemaStepB2 = Yup.object().shape({
      otp: Yup.string()
        .required("* กรุณากรอกรหัส OTP")
        .matches(/^([0-9]{6})$/, "* รหัส OTP ไม่ถูกต้อง")
        .label("รหัส OTP"),
    });
    const schemaStepB3 = Yup.object().shape({
      bank: Yup.string().required("* กรุณาเลือกธนาคาร").label("ธนาคาร"),
      accNo: Yup.string()
        .required("* กรุณากรอกเลขที่บัญชี")
        .matches(/^([0-9]{10,12})$/, "* เลขที่บัญชีไม่ถูกต้อง")
        .label("เลขที่บัญชี"),
      password: Yup.string()
        .required("* กรุณากรอกรหัสผ่าน")
        .min(6, "* รหัสผ่านความยาวต้องไม่ต่ำกว่า 6 ตัวอักษร")
        .label("รหัสผ่าน"),
      password_confirmation: Yup.string()
        .required("* กรุณายืนยันรหัสผ่านใหม่อีกครั้ง")
        .oneOf([Yup.ref("password"), null], "รหัสผ่านไม่ตรงกัน")
        .label("ยืนยันรหัสผ่าน"),
      promotionId: Yup.string().label("โปรโมชั่น"),
      knowMe: Yup.string().when((obj, schema) => {
        //your condition here
        if (knowMe.value) {
          return schema
            .required("* กรุณาเลือกรู้จักเราช่องทางไหน")
            .label("รู้จักเราช่องทางไหน");
        }
        return schema.notRequired().label("รู้จักเราช่องทางไหน");
      }),
    });
    const schemaStepC1 = Yup.object().shape({
      mobileNumber: Yup.string()
        .required("* กรุณากรอกเบอร์โทรศัพท์")
        .matches(/^(0[0-9]{9})$/, "* เบอร์โทรศัพท์ไม่ถูกต้อง")
        .label("เบอร์โทรศัพท์"),
      bank: Yup.string().required("* กรุณาเลือกธนาคาร").label("ธนาคาร"),
      accNo: Yup.string()
        .required("* กรุณากรอกเลขที่บัญชี")
        .matches(/^([0-9]{10,12})$/, "* เลขที่บัญชีไม่ถูกต้อง")
        .label("เลขที่บัญชี"),
      password: Yup.string()
        .required("* กรุณากรอกรหัสผ่าน")
        .min(6, "* รหัสผ่านความยาวต้องไม่ต่ำกว่า 6 ตัวอักษร")
        .label("รหัสผ่าน"),
      /*       password_confirmation: Yup.string()
        .required("* กรุณายืนยันรหัสผ่านใหม่อีกครั้ง")
        .oneOf([Yup.ref("password"), null], "รหัสผ่านไม่ตรงกัน")
        .label("ยืนยันรหัสผ่าน"), */
      promotionId: Yup.string().label("โปรโมชั่น"),
      knowMe: Yup.string().when((obj, schema) => {
        //your condition here
        if (knowMe.value) {
          return schema
            .required("* กรุณาเลือกรู้จักเราช่องทางไหน")
            .label("รู้จักเราช่องทางไหน");
        }
        return schema.notRequired().label("รู้จักเราช่องทางไหน");
      }),
    });
    const submitStepA1 = async (values) => {
      if (!submitStepA1ButtonRef.value) {
        return;
      }

      //Disable button
      submitStepA1ButtonRef.value.disabled = true;
      // Activate indicator
      submitStepA1ButtonRef.value.setAttribute("data-kt-indicator", "on");

      ApiService.post("front/register-step-a-1", values)
        .then(({ data }) => {
          submitStepA1ButtonRef.value?.removeAttribute("data-kt-indicator");
          submitStepA1ButtonRef.value!.disabled = true;
          referId.value = data.rid;
          state.value = data.nextStep;
          stateTitle.value = data.message;
          otpRefNo.value = data.ref;
          dataTemp.value = data;
          //otpInputRef.value!.removeAttribute("readonly");
          //counting.value = true;
          startCounting();
        })
        .catch(({ response }) => {
          submitStepA1ButtonRef.value?.removeAttribute("data-kt-indicator");
          submitStepA1ButtonRef.value!.disabled = false;
          let errorMessage = "มีข้อผิดพลาด";
          if (response?.data?.error?.message) {
            errorMessage = response.data.error.message;
          } else if (response?.data?.errors) {
            const keys = Object.keys(response.data.errors);
            const ek = response.data.errors[keys[0]];
            errorMessage = ek;
          }
          Swal.fire({
            text: errorMessage,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "ตกลง",
            customClass: {
              confirmButton: "btn fw-semobold btn-danger",
            },
          }).then(({ data }) => {
            submitStepA1ButtonRef.value?.removeAttribute("data-kt-indicator");
            submitStepA1ButtonRef.value!.disabled = false;
          });
        });
    };
    const submitStepA2 = async (values) => {
      if (!submitStepA2ButtonRef.value) {
        return;
      }

      //Disable button
      submitStepA2ButtonRef.value.disabled = true;
      // Activate indicator
      submitStepA2ButtonRef.value.setAttribute("data-kt-indicator", "on");

      ApiService.post("front/register-step-a-2", values)
        .then(({ data }) => {
          submitStepA2ButtonRef.value?.removeAttribute("data-kt-indicator");
          submitStepA2ButtonRef.value!.disabled = false;

          referId.value = data.rid;
          state.value = data.nextStep;
          stateTitle.value = data.message;
          dataTemp.value = data;
        })
        .catch(({ response }) => {
          submitStepA2ButtonRef.value?.removeAttribute("data-kt-indicator");
          submitStepA2ButtonRef.value!.disabled = false;
          let errorMessage = "มีข้อผิดพลาด";
          if (response?.data?.error?.message) {
            errorMessage = response.data.error.message;
          } else if (response?.data?.errors) {
            const keys = Object.keys(response.data.errors);
            const ek = response.data.errors[keys[0]];
            errorMessage = ek;
          }

          Swal.fire({
            text: errorMessage,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "ตกลง",
            customClass: {
              confirmButton: "btn fw-semobold btn-danger",
            },
          }).then(({ data }) => {
            submitStepA2ButtonRef.value?.removeAttribute("data-kt-indicator");
            submitStepA2ButtonRef.value!.disabled = false;
          });
        });
    };
    const submitStepA3 = async (values) => {
      if (!submitStepA3ButtonRef.value) {
        return;
      }

      //Disable button
      submitStepA3ButtonRef.value.disabled = true;
      // Activate indicator
      submitStepA3ButtonRef.value.setAttribute("data-kt-indicator", "on");

      ApiService.post("front/register-step-a-3", values)
        .then(({ data }) => {
          submitStepA3ButtonRef.value?.removeAttribute("data-kt-indicator");
          submitStepA3ButtonRef.value!.disabled = false;

          if (data.needApproved) {
            Swal.fire({
              html: data.message,
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง",
              customClass: {
                confirmButton: "btn btn-primary",
              },
            }).then(({ data }) => {
              emit("register-complete");
              state.value = "";
              signUpCode.value = "";
            });
          } else {
            if (data.processQueue) {
              isLoading.value = true;
              referId.value = data.hash;
              setSignalR(data.hash);
            } else {
              Swal.fire({
                html: data.message,
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "ตกลง",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              }).then(() => {
                emit("register-complete");
                state.value = "";
                signUpCode.value = "";
              });
            }
          }
        })
        .catch(({ response }) => {
          //console.log(response);
          submitStepA3ButtonRef.value?.removeAttribute("data-kt-indicator");
          submitStepA3ButtonRef.value!.disabled = false;
          let errorMessage = "มีข้อผิดพลาด";
          if (response?.data?.error?.message) {
            errorMessage = response.data.error.message;
          } else if (response?.data?.errors) {
            const keys = Object.keys(response.data.errors);
            const ek = response.data.errors[keys[0]];
            errorMessage = ek;
          }

          Swal.fire({
            text: errorMessage,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "ตกลง",
            customClass: {
              confirmButton: "btn fw-semobold btn-danger",
            },
          }).then(({ data }) => {
            submitStepA3ButtonRef.value?.removeAttribute("data-kt-indicator");
            submitStepA3ButtonRef.value!.disabled = false;
          });
        });
    };
    const submitStepB1 = async (values) => {
      if (!submitStepB1ButtonRef.value) {
        return;
      }

      //Disable button
      submitStepB1ButtonRef.value.disabled = true;
      // Activate indicator
      submitStepB1ButtonRef.value.setAttribute("data-kt-indicator", "on");

      ApiService.post("front/register-step-b-1", values)
        .then(({ data }) => {
          submitStepB1ButtonRef.value?.removeAttribute("data-kt-indicator");
          submitStepB1ButtonRef.value!.disabled = false;
          referId.value = data.rid;
          state.value = data.nextStep;
          stateTitle.value = data.message;
          otpRefNo.value = data.ref;
          dataTemp.value = data;
          //otpInputRef.value!.removeAttribute("readonly");
          //counting.value = true;
          startCounting();
        })
        .catch(({ response }) => {
          submitStepB1ButtonRef.value?.removeAttribute("data-kt-indicator");
          submitStepB1ButtonRef.value!.disabled = false;
          let errorMessage = "มีข้อผิดพลาด";
          if (response?.data?.error?.message) {
            errorMessage = response.data.error.message;
          } else if (response?.data?.errors) {
            const keys = Object.keys(response.data.errors);
            const ek = response.data.errors[keys[0]];
            errorMessage = ek;
          }

          Swal.fire({
            text: errorMessage,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "ตกลง",
            customClass: {
              confirmButton: "btn fw-semobold btn-danger",
            },
          }).then(({ data }) => {
            submitStepB1ButtonRef.value?.removeAttribute("data-kt-indicator");
            submitStepB1ButtonRef.value!.disabled = false;
          });
        });
    };
    const submitStepB2 = async (values) => {
      if (!submitStepB2ButtonRef.value) {
        return;
      }

      //Disable button
      submitStepB2ButtonRef.value.disabled = true;
      // Activate indicator
      submitStepB2ButtonRef.value.setAttribute("data-kt-indicator", "on");

      ApiService.post("front/register-step-b-2", values)
        .then(({ data }) => {
          submitStepB2ButtonRef.value?.removeAttribute("data-kt-indicator");
          submitStepB2ButtonRef.value!.disabled = false;

          referId.value = data.rid;
          state.value = data.nextStep;
          stateTitle.value = data.message;
          dataTemp.value = data;
        })
        .catch(({ response }) => {
          submitStepB2ButtonRef.value?.removeAttribute("data-kt-indicator");
          submitStepB2ButtonRef.value!.disabled = false;
          let errorMessage = "มีข้อผิดพลาด";
          if (response?.data?.error?.message) {
            errorMessage = response.data.error.message;
          } else if (response?.data?.errors) {
            const keys = Object.keys(response.data.errors);
            const ek = response.data.errors[keys[0]];
            errorMessage = ek;
          }

          Swal.fire({
            text: errorMessage,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "ตกลง",
            customClass: {
              confirmButton: "btn fw-semobold btn-danger",
            },
          }).then(({ data }) => {
            submitStepB2ButtonRef.value?.removeAttribute("data-kt-indicator");
            submitStepB2ButtonRef.value!.disabled = false;
          });
        });
    };
    const submitStepB3 = async (values) => {
      if (!submitStepB3ButtonRef.value) {
        return;
      }

      //Disable button
      submitStepB3ButtonRef.value.disabled = true;
      // Activate indicator
      submitStepB3ButtonRef.value.setAttribute("data-kt-indicator", "on");

      ApiService.post("front/register-step-b-3", values)
        .then(({ data }) => {
          submitStepB3ButtonRef.value?.removeAttribute("data-kt-indicator");
          submitStepB3ButtonRef.value!.disabled = false;

          if (data.needApproved) {
            Swal.fire({
              html: data.message,
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง",
              customClass: {
                confirmButton: "btn btn-primary",
              },
            }).then(({ data }) => {
              emit("register-complete");
              state.value = "";
              signUpCode.value = "";
            });
          } else {
            if (data.processQueue) {
              isLoading.value = true;
              referId.value = data.hash;
              setSignalR(data.hash);
            } else {
              Swal.fire({
                html: data.message,
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "ตกลง",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              }).then(() => {
                emit("register-complete");
                state.value = "";
                signUpCode.value = "";
              });
            }
          }
        })
        .catch(({ response }) => {
          submitStepB3ButtonRef.value?.removeAttribute("data-kt-indicator");
          submitStepB3ButtonRef.value!.disabled = false;
          let errorMessage = "มีข้อผิดพลาด";
          if (response?.data?.error?.message) {
            errorMessage = response.data.error.message;
          } else if (response?.data?.errors) {
            const keys = Object.keys(response.data.errors);
            const ek = response.data.errors[keys[0]];
            errorMessage = ek;
          }
          Swal.fire({
            text: errorMessage,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "ตกลง",
            customClass: {
              confirmButton: "btn fw-semobold btn-danger",
            },
          }).then(({ data }) => {
            submitStepB3ButtonRef.value?.removeAttribute("data-kt-indicator");
            submitStepB3ButtonRef.value!.disabled = false;
          });
        });
    };
    const submitStepC1 = async (values) => {
      if (!submitStepC1ButtonRef.value) {
        return;
      }
      state.value = "StepC2";
    };
    const submitStepC2 = async (values) => {
      if (!submitStepC2ButtonRef.value) {
        return;
      }
      //Disable button
      submitStepC2ButtonRef.value!.disabled = true;
      // Activate indicator
      submitStepC2ButtonRef.value?.setAttribute("data-kt-indicator", "on");

      ApiService.post("front/register-step-c-2", values)
        .then(({ data }) => {
          submitStepC2ButtonRef.value?.removeAttribute("data-kt-indicator");
          submitStepC2ButtonRef.value!.disabled = false;
          //console.log(data);
          if (data.needApproved) {
            Swal.fire({
              html: data.message,
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง",
              customClass: {
                confirmButton: "btn btn-primary",
              },
            }).then(({ data }) => {
              emit("register-complete");
              state.value = "";
              signUpCode.value = "";
            });
          } else {
            if (data.processQueue) {
              isLoading.value = true;
              referId.value = data.hash;
              setSignalR(data.hash);
            } else {
              Swal.fire({
                html: data.message,
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "ตกลง",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              }).then(() => {
                emit("register-complete");
                state.value = "";
                signUpCode.value = "";
              });
            }
          }
        })
        .catch(({ response }) => {
          submitStepC2ButtonRef.value?.removeAttribute("data-kt-indicator");
          submitStepC2ButtonRef.value!.disabled = false;
          let errorMessage = "มีข้อผิดพลาด";
          if (response?.data?.error?.message) {
            errorMessage = response.data.error.message;
          } else if (response?.data?.errors) {
            const keys = Object.keys(response.data.errors);
            const ek = response.data.errors[keys[0]];
            errorMessage = ek;
          }

          Swal.fire({
            text: errorMessage,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "ตกลง",
            customClass: {
              confirmButton: "btn fw-semobold btn-danger",
            },
          });
        });
    };
    const onlyNumber = ($event) => {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    };
    const validateAcc = ($event) => {
      //console.log($event.target.selectedIndex);
      if (dna.value) {
        return;
      }
      if (
        registerCFormData.value?.accNo &&
        registerCFormData.value?.bank &&
        registerCFormData.value?.mobileNumber &&
        registerCFormData.value?.accNo.length >= 10 &&
        registerCFormData.value?.mobileNumber.length == 10
      ) {
        //console.log(registerCFormData.value?.accNo);
        //console.log(registerCFormData.value?.mobileNumber);
        //console.log(registerCFormData.value?.bank);

        //const pp = registerCFormData.value;
        loadingAcc.value = true;
        ApiService.postData("front/register-step-c-1", registerCFormData.value)
          .then(({ data }) => {
            referId.value = data.rid;
            dataTemp.value = data;
            registerCFormData.value.firstName = data.firstName;
            registerCFormData.value.lastName = data.lastName;
            loadingAcc.value = false;
          })
          .catch(({ response }) => {
            registerCFormData.value.firstName = "";
            registerCFormData.value.lastName = "";
            loadingAcc.value = false;
          });
      }

      //console.log(accNoInputRef.value);
      //console.log(bankInputRef.value);
    };
    const startCounting = () => {
      submitStepA1ButtonRef.value!.disabled = true;
      submitStepB1ButtonRef.value!.disabled = true;
      mobileNumberInputRef.value!.readOnly = true;
      counting.value = true;
    };
    const stopCounting = () => {
      counting.value = false;
      submitStepA1ButtonRef.value!.disabled = false;
      submitStepB1ButtonRef.value!.disabled = false;
      mobileNumberInputRef.value!.readOnly = false;
    };

    const initRegisterStep = async () => {
      ApiService.get("front/register-init", "?sponsorId=" + sponsorId.value)
        .then(({ data }) => {
          signUpCode.value = data.signUpCode;
          banks.value = data.banks;
          dna.value = data.dna;
          dataTemp.value = data;
          knowMe.value = data.knowMe;
          //state.value = "StepB3";
          //console.log(state.value);
          //console.log(signUpCode.value);
        })
        .catch(({ response }) => {
          /*           console.log(response);
          Swal.fire({
            text: response ? response.statusText : "มีข้อผิดพลาด",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "ตกลง",
            customClass: {
              confirmButton: "btn fw-semobold btn-danger",
            },
          }); */
        });
    };

    const resetData = () => {
      state.value = "";
    };

    const setSignalR = (id) => {
      signalr.on("ON_USER_CREATED", (o) => {
        //console.log("ON_USER_CREATED");
        if (o.refId && o.refId === id) {
          isLoading.value = false;
          signalr.off("ON_USER_CREATED");
          if (o.status === 1) {
            submitStepC2ButtonRef.value?.removeAttribute("data-kt-indicator");
            submitStepC2ButtonRef.value!.disabled = false;
            Swal.fire({
              html: o.message,
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง",
              customClass: {
                confirmButton: "btn btn-primary",
              },
            }).then(() => {
              emit("register-complete");
              state.value = "";
              signUpCode.value = "";
            });
          } else {
            submitStepC2ButtonRef.value?.removeAttribute("data-kt-indicator");
            submitStepC2ButtonRef.value!.disabled = false;
            Swal.fire({
              text: o.message ? o.message : "มีข้อผิดพลาด กรุณาลองใหม่",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "ตกลง",
              customClass: {
                confirmButton: "btn fw-semobold btn-danger",
              },
            });
          }
        }
      });
    };
    watch(
      () => props.callTime,
      () => {
        resetData();
      }
    );
    onMounted(async () => {
      state.value = "";
      sponsorId.value = store.getters.sponsorId ?? "";
      seoId.value = store.getters.seoId;

      nextTick(async () => {
        await initRegisterStep();
      });
      nextTick(() => {
        PasswordMeterComponent.bootstrap();
      });
    });
    return {
      value,
      state,
      stateTitle,
      sponsorId,
      seoId,
      referId,
      otpRefNo,
      banks,
      dataTemp,
      dna,
      schemaStepA1,
      schemaStepA2,
      schemaStepA3,
      schemaStepB1,
      schemaStepB2,
      schemaStepB3,
      schemaStepC1,
      submitStepA1,
      submitStepA2,
      submitStepA3,
      submitStepB1,
      submitStepB2,
      submitStepB3,
      submitStepC1,
      submitStepC2,
      submitStepA1ButtonRef,
      submitStepA2ButtonRef,
      submitStepA3ButtonRef,
      submitStepB1ButtonRef,
      submitStepB2ButtonRef,
      submitStepB3ButtonRef,
      submitStepC1ButtonRef,
      submitStepC2ButtonRef,
      loadingAcc,
      onlyNumber,
      validateAcc,
      initRegisterStep,
      signUpCode,
      counting,
      stopCounting,
      mobileNumberInputRef,
      accNoInputRef,
      bankInputRef,
      startCounting,
      resetData,
      registerCFormData,
      isLoading,
      knowMe,
      setSignalR,
    };
  },
});
